import { ChangeEvent, FC } from 'react';
import { TimePickerProps } from '../types';
import { InputsRange } from './styles';
import { Flex } from 'shared/ui/flex';

export const CalendarTimePickerRange: FC<TimePickerProps> = ({
	timeRange,
	onTimeChange,
}) => {
	const handleStartTimeChange = (event: ChangeEvent<HTMLInputElement>) => {
		onTimeChange(event.target.value);
	};
	const handleEndTimeChange = (event: ChangeEvent<HTMLInputElement>) => {
		onTimeChange(event.target.value, false);
	};

	return (
		<InputsRange>
			{timeRange && (
				<Flex $gap="5px">
					<input
						type="time"
						value={timeRange.from}
						onChange={handleStartTimeChange}
					/>
					<input
						type="time"
						value={timeRange.to}
						onChange={handleEndTimeChange}
					/>
				</Flex>
			)}
		</InputsRange>
	);
};
